import { Link } from "react-router-dom";
import Arrow from "../SVG/ArrowSvg";
import "./placeholder.scss";

const Placeholder = () => {
  return (
    <div className="placeholder">
      <div className="text-container">
        <p className="title">In de verbouwing</p>
        <p className="text">
          Mijn website wordt momenteel mooi gemaakt door de webhelden van
          IZ|Regale. Kun je niet wachten en wil je nu al meer weten over mijn
          lezingen, trainingen en coachingtrajecten? Stuur me dan een email en
          ik vertel je alles. Of wil je heel graag mijn nieuwe boek lezen?
          bestel hem dan hieronder!
        </p>
        <div className="button-container">
          <a
            target="_blank"
            href="https://www.bol.com/nl/nl/p/gedachten-zijn-klootzakken/9300000166623295/?bltgh=g6wvBF0pwoGa4wpkbyRAOw.2_14.15.ProductPageUrl"
            rel="noreferrer"
            className="button"
          >
            <Arrow className="arrow" />
            <p className="text-button">Koop hier mijn nieuwste boek</p>
          </a>
          <a
            target="_blank"
            href="mailto:sanne@sannevanarnhem.nl"
            rel="noreferrer"
            className="button"
          >
            <Arrow className="arrow" />
            <p className="text-button">Stuur mij een berichtje!</p>
          </a>
          <Link className="button" to="..">
            <Arrow className="arrow" />
            <p className="text-button">Terug naar de home pagina</p>
          </Link>
        </div>
      </div>
    </div>
  );
};
export default Placeholder;
